import React from 'react'
import MediaQuery from "react-responsive";
import bghome from "../home.png"
const Home = () => {
    return (
        <div>
            <div className="container mt-4">
						<div className="text-center display-5">
							Selamat Datang Di Halaman Utama Guru
						</div>
						<div className="text-center blockquote">
							Silahkan Langsung Klik Menu Sidebar Agar Dapat Melihat Nilai Siswa
						</div>
						<MediaQuery minWidth={476} maxWidth={1824}>
							<div className="w-100">
								<img src={bghome} alt={bghome} />
							</div>
						</MediaQuery>
						<MediaQuery maxWidth={475}>
							<img src={bghome} alt={bghome} style={{height:'300px', width:'335px',marginLeft:'10px'}} />
						</MediaQuery>
					</div>
        </div>
    )
}

export default Home
